import {percentageGroup} from "../../utils/step.fields.utils.js";
import moment from "moment/moment";

const step_schema_fleet = [
    // todo add disclaimer - all uk licence, more than 1 year
    // todo add t&cs
    //company
    {
        key: 'company_name',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY
    },
    {
        key: 'postcode',
        label: 'What is your business premises postcode?',
        placeholder: 'Premises Postcode',
        type: 'address-lookup-step',
        headline: 'Company',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY
    },
    {
        key: 'address1',
        skip_question: true
    },
    {
        key: 'address2',
        skip_question: true
    },
    {
        key: 'address3',
        skip_question: true
    },
    {
        key: 'address4',
        skip_question: true
    },
    {
        key: 'city',
        skip_question: true
    },
    {
        key: 'company_year',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY
    },
    {
        key: 'company_business',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
        children: [
            {
                key: 'private_hire',
                label: 'Are the vehicles used for Private Hire?',
                required_if: parent_value => parent_value && parent_value.match(/taxi /i),
                percentage_group: percentageGroup.PERCENTAGE_COMPANY
            },
            {
                key: 'public_hire',
                label: 'Are the vehicles used for Public Hire?',
                required_if: parent_value => parent_value && parent_value.match(/taxi /i),
                percentage_group: percentageGroup.PERCENTAGE_COMPANY
            },
        ],
    },
    //vehicle
    {
        key: 'haulage_use',
        label: 'Are the vehicles used for haulage?',
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE
    },
    {
        key: 'number_of_vehicles',
        value: 3,
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE
    },
    {
        key: 'vehicle_types',
        percentage_group: percentageGroup.PERCENTAGE_VEHICLE,
        extra_children: [
            {
                key: 'vans',
            },
            {
                key: 'cars',
            },
            {
                key: 'motorbikes',
            },
            {
                key: 'pickups',
            },
            {
                key: 'trucks',
            },
            {
                key: 'taxis',
            },
            {
                key: 'minibuses',
            },
            {
                key: 'other',
            },
        ],
    },

    //driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone',
    },
    {
        key: 'email',
    },
    //policy
    {
        key: 'driving_restrictions',
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    {
        key: 'cover_date',
        value: moment().add(5, 'days').format('DD/MM/YYYY'),
    },
    {
        key: 'claims_experience',
        percentage_group: percentageGroup.PERCENTAGE_POLICY
    },
    {
        key: 'marketing',
        extra_children: [
            {
                key: 'marketing_phone',
            },
            {
                key: 'marketing_email',
            },
            {
                key: 'marketing_sms',
            },
        ],
    },
    {
        key: 'end',
    },
];
export default step_schema_fleet;
